export type FailureClassification =
  | { kind: "aborted" }
  | { kind: "session"; status: 401 }
  | { kind: "technical"; status?: number }
  | {
      kind: "operational";
      status?: number;
      title: string;
      description: string;
    };

type FailureWithStatus = {
  status?: unknown;
};

function readStatus(failure: unknown) {
  if (!failure || typeof failure !== "object") {
    return undefined;
  }

  const status = (failure as FailureWithStatus).status;
  return typeof status === "number" ? status : undefined;
}

export function isAbortFailure(failure: unknown) {
  return (
    failure instanceof Error &&
    failure.name === "AbortError"
  );
}

export function isNetworkFailure(failure: unknown) {
  return failure instanceof TypeError;
}

export function classifyFailure(failure: unknown): FailureClassification {
  if (isAbortFailure(failure)) {
    return { kind: "aborted" };
  }

  const status = readStatus(failure);

  if (status === 401) {
    return { kind: "session", status };
  }

  if (
    status === 0 ||
    (status !== undefined && status >= 500 && status <= 599) ||
    (status === undefined && isNetworkFailure(failure))
  ) {
    return status === undefined
      ? { kind: "technical" }
      : { kind: "technical", status };
  }

  if (status === 400) {
    return {
      kind: "operational",
      status,
      title: "Não foi possível concluir a solicitação",
      description: "Revise os dados informados e tente novamente.",
    };
  }

  if (status === 403) {
    return {
      kind: "operational",
      status,
      title: "Ação não permitida",
      description:
        "Você não tem permissão ou acesso ao escopo necessário para esta ação.",
    };
  }

  if (status === 404) {
    return {
      kind: "operational",
      status,
      title: "Registro não encontrado",
      description:
        "O registro não está mais disponível ou foi alterado. Atualize os dados e tente novamente.",
    };
  }

  if (status === 409) {
    return {
      kind: "operational",
      status,
      title: "Os dados foram alterados",
      description:
        "Atualize as informações antes de tentar concluir a ação novamente.",
    };
  }

  return {
    kind: "operational",
    ...(status === undefined ? {} : { status }),
    title: "Não foi possível concluir a operação",
    description: "Tente novamente. Se o problema continuar, revise os dados.",
  };
}
